import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { AdminLogin } from "./AdminLogin";
import { AdminDashboard } from "./AdminDashboard";

export default function Admin() {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false))
      .finally(() => setChecking(false));
  }, []);

  if (checking) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gb-black" data-testid="admin-loading">
        <Loader2 className="h-6 w-6 animate-spin text-gb-silver" aria-label="Carregando" />
      </div>
    );
  }

  if (!user) return <AdminLogin onSuccess={setUser} />;
  return <AdminDashboard user={user} onLogout={() => setUser(false)} />;
}
